import { LocaleContext } from '@/Contexts/LocaleContext';
import { Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import PanelLoadingPlaceholder from '@/components/myaccount/Applicant_MyAccount/PanelLoadingPlaceholder';

interface TabSubPanelContentProps {
  isPanelLoading?: boolean;
  headerText?: string;
  children: React.ReactNode;
  onSave?: () => void;
  saveDisabled?: boolean;
}

export function TabSubPanelContent({
  isPanelLoading = false,
  headerText,
  children,
  onSave,
  saveDisabled,
}: TabSubPanelContentProps) {
  const { translatedText } = useContext(LocaleContext);

  return (
    <Box display='flex' flexDirection='column' height='100%' width='100%' gap={4}>
      <Typography variant='h3'>{headerText}</Typography>
      {isPanelLoading ? (
        <PanelLoadingPlaceholder />
      ) : (
        <>
          {children}
          <Box textAlign={'center'}>
            <Button
              size='large'
              variant='primary'
              onClick={onSave}
              disabled={saveDisabled || isPanelLoading}
            >
              {translatedText.common.buttonSave}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
